

















import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import differenceInCalendarMonths from 'date-fns/difference_in_calendar_months';

@Component
export default class UserFeedbackPrompt extends Vue {
  public showDialog: boolean = false;

  private created() {
    this.$events.on('fb-prompt', (data: any) => {
      this.needsFeedback();
    });
  }

  private promptAction(type: string) {
    switch (type) {
      case 'yes':
        this.$events.fire('fb-prompt-action', { action: 'show' });
        break;
      case 'no':
        this.$events.fire('fb-prompt-action', { action: 'skip' });
        break;
      case 'later':
        this.$events.fire('fb-prompt-action', { action: 'delayed' });
        break;
    }
    this.showDialog = false;
  }

  get lastSurvey() {
    return this.$store.getters.userLoggedIn && this.$store.getters.currentUser.last_survey;
  }

  private needsFeedback() {
    this.showDialog = true;
    if (
      !this.lastSurvey ||
      (this.lastSurvey && differenceInCalendarMonths(new Date(), new Date(this.lastSurvey.updated_at)) >= 1)
    ) {
      this.showDialog = true;
    }
  }
}
